import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-033f9665"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_c_title this_link" }
const _hoisted_2 = { class: "mod_c_title" }
const _hoisted_3 = { class: "main" }
const _hoisted_4 = { class: "mod_c_tbody" }
const _hoisted_5 = { class: "sw_form" }
const _hoisted_6 = { class: "sw_form_item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swfi_title font_size" }, "表单模式：", -1))
const _hoisted_8 = { class: "swfi_content" }
const _hoisted_9 = { class: "flex_box" }
const _hoisted_10 = { class: "flex_item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex_item_title" }, "报名审核：", -1))
const _hoisted_13 = { class: "sw_form_item swfi_c_headimg" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swfi_title font_size title_info" }, "表单信息：", -1))
const _hoisted_15 = { class: "swfi_content" }
const _hoisted_16 = { class: "sw_form_item_set" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "高级设置", -1))
const _hoisted_18 = {
  key: 0,
  class: "sfis_main"
}
const _hoisted_19 = { class: "sfis_main_item" }
const _hoisted_20 = { class: "swfi_c_txt" }
const _hoisted_21 = { class: "sfis_main_item" }
const _hoisted_22 = { class: "swfi_area_wrap" }
const _hoisted_23 = { class: "swfi_area_num" }
const _hoisted_24 = {
  key: 0,
  class: "sfis_main_item swfi_c_headimg"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swfi_title font_size" }, "表单头图：", -1))
const _hoisted_26 = { class: "headimg_body" }
const _hoisted_27 = { class: "headimg_wrap" }
const _hoisted_28 = {
  key: 0,
  class: "headimg_img"
}
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "headimg_content" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "支持格式：jpg，png，bmp", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "文件大小：不超过2M", -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  class: "sfis_main_item swfi_c_headimg"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swfi_title font_size" }, "表单背景：", -1))
const _hoisted_37 = { class: "headimg_body" }
const _hoisted_38 = { class: "headimg_wrap" }
const _hoisted_39 = {
  key: 0,
  class: "headimg_img"
}
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "headimg_content" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "支持格式：jpg，png，bmp", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "文件大小：不超过2M", -1))
const _hoisted_45 = [
  _hoisted_43,
  _hoisted_44
]
const _hoisted_46 = {
  key: 2,
  class: "sfis_main_item swfi_c_headimg"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font_size" }, "表单背景 (手机端)：", -1))
const _hoisted_48 = { class: "headimg_mobile_img_wrap" }
const _hoisted_49 = { class: "headimg_mobile_img" }
const _hoisted_50 = ["src"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font_size" }, "支持格式：jpg，png，bmp", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font_size" }, "文件大小：不超过2M", -1))
const _hoisted_54 = { class: "swfi_btn_group bottom" }
const _hoisted_55 = { class: "sfis_main_item" }
const _hoisted_56 = { class: "sfis_main_item" }
const _hoisted_57 = { class: "swfi_c_txt" }
const _hoisted_58 = { class: "swfi_c_txt" }
const _hoisted_59 = { class: "sfis_main_item" }
const _hoisted_60 = { class: "swfi_c_txt" }
const _hoisted_61 = { class: "swfi_c_txt" }
const _hoisted_62 = { class: "sw_form_item swfi_c_headimg" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swfi_title font_size title_verify" }, "添加验证：", -1))
const _hoisted_64 = { class: "swfi_content" }
const _hoisted_65 = { class: "form_body_head" }
const _hoisted_66 = { class: "fbh_switch_group font_size" }
const _hoisted_67 = { class: "form_body_content" }
const _hoisted_68 = { class: "fbc_sub_group" }
const _hoisted_69 = { class: "mod_c_tbody review_wrap" }
const _hoisted_70 = { class: "viewlist_modal" }
const _hoisted_71 = { class: "viewlist_head" }
const _hoisted_72 = {
  key: 0,
  class: "mod_pagin"
}
const _hoisted_73 = { class: "modal_title" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center"} }, "开启审核功能后，用户报名注册信息必须通过人工审核后才能观看直播。", -1))

import CUpload from '@/components/CUpload.vue';
import moment, { Moment } from 'moment';
import {
  Input,
  Switch,
  Radio,
  Modal,
  Table,
  Pagination,
  Alert,
  Tabs,
  Tooltip,
  message,
  Image,
  notification,
  DatePicker,
} from 'ant-design-vue';
import { CaretRightFilled, QuestionCircleFilled, InfoCircleFilled } from '@ant-design/icons-vue';
import { VueDraggableNext } from 'vue-draggable-next';
import CRumb from '@/components/Crumb.vue';
import HeaderVue from './Header.vue';
import { computed, defineAsyncComponent, getCurrentInstance, inject, onMounted, reactive, ref, unref, watch } from 'vue';
import { FormDoc } from '@/assets';
import { sourceTxtOption, sourceTypeOption, useFormData, useLiveData, useSignupWatch, useUpload, disabled } from './signupWatch';
import { useRoute, useRouter } from 'vue-router';
import { getToken, getExamineStatus, getUserCache } from '@/plugins/cookie';
import { ModeData, SignupWClass, SwitchForm } from './type';
import { LiveInfo } from '@/store/modules/live/types';
import CDelModal from '@/components/CDelModal.vue';
import http from '@/api';
import { dragDrop } from '@/utils/format/dragDrop';
import https from '@/api/exportList';
import { useDebounce } from '@/hooks/useDebounce'; //防抖


export default /*#__PURE__*/_defineComponent({
  __name: 'SignupWatch',
  setup(__props) {

const VerifyItem = defineAsyncComponent(() => import('./VerifyItem.vue'));
const ReviewList = defineAsyncComponent(() => import('./ReviewList.vue'));
const token = getToken();

const aModal = Modal;
const aTextarea = Input.TextArea;
const aSwitch = Switch;
const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aTable = Table;
const aPagination = Pagination;
const aAlert = Alert;
const aTabs = Tabs;
const aTabPane = Tabs.TabPane;
const aTooltip = Tooltip;
const aImage = Image;
const draggable = VueDraggableNext;
const { RangePicker } = DatePicker;
const aRangePicker = RangePicker;
const dragOptions = ref({
  animation: 200,
  group: 'description',
  disabled: false,
  ghostClass: 'ghost',
});

// 头图移动端展开
const visable = ref(false);
const onChangeMIMg = () => {
  visable.value = !visable.value;
};
const headImgVisable = computed(() => (visable.value ? { className: 'on', title: '收起' } : { className: 'off', title: '展开' }));

const route = useRoute();
const studioId = route.params.studioId as string;
const langSwitch = ref(true);
const BaseData = ref<SignupWClass>({
  account_field: '',
  intro: '',
  nickname_field: '',
  status: false,
  studio_id: 0,
  title: '',
  type: true,
  pc_bg_img: 0,
  pc_bg_img_url: '',
  login_btn_text_en: 'Login',
  login_btn_text_zh: '登录',
  register_btn_text_en: 'Submit',
  register_btn_text_zh: '提交',
  bg_img: 0,
  bg_img_url: '',
  head_img: 0,
  head_img_url: '',
  form: '',
  formArr: [
    {
      id: 99,
      isInternational: false,
      isLogin: false,
      isUser_name: false,
      isVerify: false,
      isMerge: false,
      isMultipleChoice: '1',
      option: [],
      options: sourceTxtOption,
      options2: sourceTypeOption,
      preview_radio: '1',
      require: true,
      select: '1',
      select2: '9',
      tips: '请输入内容',
      title: '',
      type: 'text',
      value: '',
      verify_code: '',
    },
  ],
});
const switchData = reactive<SwitchForm>({
  isLogin: false,
  isUserName: false,
  isMerge: false,
});
const {
  switchForm,
  signupWatch,
  getForm,
  subForm,
  onChangenickName,
  onChangeLoginVerify,
  onChangeMerge,
  onChangeItemIsLogin,
  onChangeItemIsMerge,
} = useSignupWatch(BaseData, switchData);
getForm(studioId);

// upload module
const { fileList, loading, handleChange, clearImg } = useUpload(BaseData);

// form module
const { onAddItem, onDelItem, openDelModal, okDelModal, delVisible } = useFormData(BaseData);

// data list

const { showLoading, infoModal, viewListObj, columns, viewList, pageConfig, getViewList, openModal } = useLiveData();

// 多语言权限
const liveInfo = computed(() => unref(inject('liveInfo')) as LiveInfo);
// 是否为多语言子直播间
const isShowEdit = computed(() => {
  if (Object.keys(liveInfo.value).length === 0) {
    return false;
  }
  if (liveInfo.value.mode !== 5 || liveInfo.value.id === liveInfo.value.studio_pid || liveInfo.value.studio_pid === 0) {
    return true;
  }
  return false;
});
//
const alert = '编辑操作会导致部分数据丢失，建议下载数据备份！';
const subAlert = '部分功能请在“全局设置”中调整。';

// 导出数据记录
const { proxy }: any = getCurrentInstance();

const corn = ref(1);
const messageTip = ref();
const excel = useDebounce(() => {
  const data = {
    studio_id: liveInfo.value.id,
    type: 12,
    status: viewListObj.selectValue == 0 ? 0 : 1,
    is_cron_download: corn.value,
    start_at: viewListObj.datetTimeValue[0] ? new Date(viewListObj.datetTimeValue[0]) : viewListObj.datetTimeValue[0],
    end_at: viewListObj.datetTimeValue[1] ? new Date(viewListObj.datetTimeValue[1]) : viewListObj.datetTimeValue[1], 
  };
  https
    .excel_regional_distribution({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
      infoModal.visible = false;
      viewListObj.datetTimeValue = [];
      viewListObj.selectValue = 0;
    })
    .catch((res: any) => {
      messageTip.value = res.data.error;
      openNotificationWithIcon('error');
    });

  // 1 全部  2 观看量排名  3 设备占比  4 观看途径  5 访问来源  6 榜单排行  7 观看流水
  // 8 群聊记录 9 私聊记录  10 邀约码  11 直播间付费记录  12 表单用户信息 13 投票记录 14 广告统计
  // status 群聊记录 ：0 全部 1 审核过的    表单信息：0 仅表单 1 所有数据
});
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
    duration: 5,
  });
};

const activeKey = ref(1); // tab栏
const settingsVisible = ref(false); // 高级设置显示

const showTips = ref(false);
const openshowTips = () => {
  if (!signupWatch.value.examine_status) showTips.value = true;
  if (signupWatch.value.examine_status) {
    signupWatch.value.examine_status = !signupWatch.value.examine_status;
    subForm(studioId);
  }
};
const tabSwitch = ref(0);
const tabClick = () => {
  if (activeKey.value === 2 && !signupWatch.value.examine_status) {
    activeKey.value = 1;
    showTips.value = true;
    tabSwitch.value = 1;
  } else tabSwitch.value = 0;
};
const reviewRegistration = () => {
  showTips.value = false;
  signupWatch.value.examine_status = !signupWatch.value.examine_status;
  switchForm.isLogin = true;
  message.destroy();
  if (switchForm.isLogin === true) {
    signupWatch.value.status = true;
  }
  // signupWatch.value.formArr[0].isLogin = true;
  // if (signupWatch.value.formArr[0].title === '') signupWatch.value.formArr[0].title = '默认';
  // subForm(studioId).then(() => {
  //   if (tabSwitch.value === 1) setTimeout(() => (activeKey.value = 2), 1000);
  // });
};
const cancelModal = () => {
  tabSwitch.value = 0;
};
const isExamine = getExamineStatus(); // 是否是第三方审核登录
const router = useRouter();
const userCache = getUserCache() ? JSON.parse(getUserCache().toString()).other_power : '';
onMounted(() => {
  if (isExamine) {
    if (userCache === 2) activeKey.value = 2;
    else activeKey.value = 1;
  }
});

const childe = ref<number[]>([]);
const repeatChange = () => {
  childe.value.push(1);
};
watch(
  () => signupWatch.value.formArr.length,
  () => {
    childe.value.push(2);
  }
);
watch(
  () => activeKey.value,
  () => {
    return activeKey.value;
  }
);
const modeData = ref<ModeData[]>([]);
const getModeSelect = () => {
  http.live.getSWatchFromList().then((res) => {
    modeData.value = res.data.data;
  });
};
getModeSelect();

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(isExamine))
      ? (_openBlock(), _createBlock(CRumb, { key: 0 }))
      : (_openBlock(), _createBlock(HeaderVue, { key: 1 })),
    _createElementVNode("div", {
      class: _normalizeClass(["mod_wrap mod_set_wrap mod_c", { examine_view: _unref(isExamine) }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(" 报名观看 "),
          _createVNode(_unref(aSwitch), {
            class: "btns_txt",
            checked: _unref(signupWatch).status,
            "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_unref(signupWatch).status) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(subForm)(_unref(studioId))))
          }, null, 8, ["checked"])
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(aTabs), {
          type: "card",
          activeKey: activeKey.value,
          "onUpdate:activeKey": _cache[16] || (_cache[16] = ($event: any) => ((activeKey).value = $event)),
          onChange: tabClick
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_unref(aTabPane), {
              key: 1,
              tab: "观众注册",
              disabled: _unref(userCache) === 2
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_unref(aRadioGroup), {
                            value: _unref(signupWatch).type,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(signupWatch).type) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(aRadio), {
                                value: true,
                                class: "font_size"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("图文模式")
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(aRadio), {
                                value: false,
                                class: "font_size"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("海报模式")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"]),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", null, [
                              _createVNode(_unref(aTooltip), null, {
                                title: _withCtx(() => [
                                  _createTextVNode("1. 开启审核功能后，用户报名注册信息必须通过人工审核后才能观看直播；"),
                                  _hoisted_11,
                                  _createTextVNode("2. 报名审核需要配合登录验证功能使用。")
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_unref(QuestionCircleFilled))
                                ]),
                                _: 1
                              }),
                              _hoisted_12,
                              _createVNode(_unref(aSwitch), {
                                checked: _unref(signupWatch).examine_status,
                                onChange: openshowTips
                              }, null, 8, ["checked"])
                            ]),
                            _createVNode(_component_a_button, {
                              type: "link",
                              class: "btn",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(openModal)(_unref(signupWatch).formArr, _unref(studioId))))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("数据记录>")
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["sfis_title", { on: settingsVisible.value }]),
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (settingsVisible.value = !settingsVisible.value))
                          }, [
                            _hoisted_17,
                            _createVNode(_unref(CaretRightFilled), { class: "sfis_title_icon" })
                          ], 2),
                          (settingsVisible.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_a_input, {
                                    value: _unref(signupWatch).title,
                                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(signupWatch).title) = $event)),
                                    maxlength: 80,
                                    class: "swfi_c_input",
                                    size: "large",
                                    placeholder: "请输入表单标题"
                                  }, {
                                    suffix: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(signupWatch).title.length) + "/80", 1)
                                    ]),
                                    _: 1
                                  }, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                  _createElementVNode("div", _hoisted_22, [
                                    _createVNode(_unref(aTextarea), {
                                      value: _unref(signupWatch).intro,
                                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(signupWatch).intro) = $event)),
                                      maxLength: "300",
                                      class: "swfi_c_textarea font_size",
                                      size: "large",
                                      placeholder: "请输入表单简介"
                                    }, null, 8, ["value"]),
                                    _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(signupWatch).intro.length) + "/300", 1)
                                  ])
                                ]),
                                (_unref(signupWatch).type)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                      _hoisted_25,
                                      _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("div", _hoisted_27, [
                                          (!_unref(signupWatch).head_img_url)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                                _createElementVNode("img", {
                                                  src: _unref(FormDoc),
                                                  alt: ""
                                                }, null, 8, _hoisted_29)
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_30, [
                                            _createVNode(CUpload, {
                                              "file-list": _unref(fileList),
                                              "handle-change": (info) => _unref(handleChange)(info,'coverImg'),
                                              loading: _unref(loading).coverImg,
                                              "image-name": _unref(signupWatch).head_img_url,
                                              "click-stop": () => _unref(clearImg)('coverImg'),
                                              plus: false,
                                              class: "header_cover"
                                            }, _createSlots({ _: 2 }, [
                                              (!_unref(signupWatch).head_img_url)
                                                ? {
                                                    name: "uploadImg",
                                                    fn: _withCtx(() => [
                                                      _createVNode(_component_a_button, {
                                                        type: "link",
                                                        class: "upload_btn"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode("点击上传")
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    key: "0"
                                                  }
                                                : undefined
                                            ]), 1032, ["file-list", "handle-change", "loading", "image-name", "click-stop"]),
                                            (!_unref(signupWatch).head_img_url)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_34))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (!_unref(signupWatch).type)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                      _hoisted_36,
                                      _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("div", _hoisted_38, [
                                          (!_unref(signupWatch).pc_bg_img_url)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                _createElementVNode("img", {
                                                  src: _unref(FormDoc),
                                                  alt: ""
                                                }, null, 8, _hoisted_40)
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_41, [
                                            _createVNode(CUpload, {
                                              "file-list": _unref(fileList),
                                              "handle-change": (info) => _unref(handleChange)(info,'headImg'),
                                              loading: _unref(loading).headImg,
                                              "image-name": _unref(signupWatch).pc_bg_img_url,
                                              "click-stop": () => _unref(clearImg)('headImg'),
                                              plus: false,
                                              class: "header_cover"
                                            }, _createSlots({ _: 2 }, [
                                              (!_unref(signupWatch).pc_bg_img_url)
                                                ? {
                                                    name: "uploadImg",
                                                    fn: _withCtx(() => [
                                                      _createVNode(_component_a_button, {
                                                        type: "link",
                                                        class: "upload_btn"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode("点击上传")
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    key: "0"
                                                  }
                                                : undefined
                                            ]), 1032, ["file-list", "handle-change", "loading", "image-name", "click-stop"]),
                                            (!_unref(signupWatch).pc_bg_img_url)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_45))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (!_unref(signupWatch).type)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                      _hoisted_47,
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["headimg_mobile_body", _unref(headImgVisable).className])
                                      }, [
                                        _createElementVNode("div", _hoisted_48, [
                                          _createVNode(CUpload, {
                                            "file-list": _unref(fileList),
                                            "handle-change": (info) => _unref(handleChange)(info,'headImgM'),
                                            loading: _unref(loading).headImgM,
                                            plus: false,
                                            imageName: _unref(signupWatch).bg_img_url,
                                            clickStop: () => _unref(clearImg)('headImgM'),
                                            class: "ant_upload"
                                          }, {
                                            uploadImg: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_49, [
                                                _createElementVNode("img", {
                                                  src: _unref(FormDoc),
                                                  alt: ""
                                                }, null, 8, _hoisted_50),
                                                _hoisted_51,
                                                _createVNode(_component_a_button, {
                                                  type: "link",
                                                  class: "upload_btn font_size"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("点击上传")
                                                  ]),
                                                  _: 1
                                                }),
                                                _hoisted_52,
                                                _hoisted_53
                                              ])
                                            ]),
                                            _: 1
                                          }, 8, ["file-list", "handle-change", "loading", "imageName", "clickStop"])
                                        ])
                                      ], 2),
                                      _createElementVNode("div", _hoisted_54, [
                                        _createVNode(_component_a_button, {
                                          class: "primary_color font_size",
                                          type: "link",
                                          onClick: onChangeMIMg
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(headImgVisable).title) + ">>>", 1)
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_55, [
                                  _createTextVNode(" 语言切换     "),
                                  _createVNode(_unref(aRadioGroup), {
                                    value: langSwitch.value,
                                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((langSwitch).value = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(aRadio), {
                                        value: true,
                                        class: "font_size"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("中文")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(aRadio), {
                                        value: false,
                                        class: "font_size"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("英文")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_56, [
                                  (langSwitch.value)
                                    ? (_openBlock(), _createBlock(_component_a_input, {
                                        key: 0,
                                        value: _unref(signupWatch).login_btn_text_zh,
                                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(signupWatch).login_btn_text_zh) = $event)),
                                        maxlength: 20,
                                        class: "swfi_c_input",
                                        size: "large",
                                        placeholder: "登录按钮"
                                      }, {
                                        suffix: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_57, _toDisplayString(_unref(signupWatch).login_btn_text_zh.length) + "/20", 1)
                                        ]),
                                        _: 1
                                      }, 8, ["value"]))
                                    : (_openBlock(), _createBlock(_component_a_input, {
                                        key: 1,
                                        value: _unref(signupWatch).login_btn_text_en,
                                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_unref(signupWatch).login_btn_text_en) = $event)),
                                        maxlength: 20,
                                        class: "swfi_c_input",
                                        size: "large",
                                        placeholder: "Login"
                                      }, {
                                        suffix: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_58, _toDisplayString(_unref(signupWatch).login_btn_text_en.length) + "/20", 1)
                                        ]),
                                        _: 1
                                      }, 8, ["value"]))
                                ]),
                                _createElementVNode("div", _hoisted_59, [
                                  (langSwitch.value)
                                    ? (_openBlock(), _createBlock(_component_a_input, {
                                        key: 0,
                                        value: _unref(signupWatch).register_btn_text_zh,
                                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_unref(signupWatch).register_btn_text_zh) = $event)),
                                        maxlength: 20,
                                        class: "swfi_c_input",
                                        size: "large",
                                        placeholder: "报名按钮"
                                      }, {
                                        suffix: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_60, _toDisplayString(_unref(signupWatch).register_btn_text_zh.length) + "/20", 1)
                                        ]),
                                        _: 1
                                      }, 8, ["value"]))
                                    : (_openBlock(), _createBlock(_component_a_input, {
                                        key: 1,
                                        value: _unref(signupWatch).register_btn_text_en,
                                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_unref(signupWatch).register_btn_text_en) = $event)),
                                        maxlength: 20,
                                        class: "swfi_c_input",
                                        size: "large",
                                        placeholder: "Enter"
                                      }, {
                                        suffix: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_61, _toDisplayString(_unref(signupWatch).register_btn_text_en.length) + "/20", 1)
                                        ]),
                                        _: 1
                                      }, 8, ["value"]))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _hoisted_63,
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("div", _hoisted_66, [
                            _createTextVNode(" 默认用户名： "),
                            _createVNode(_unref(aSwitch), {
                              "checked-children": "开",
                              "un-checked-children": "关",
                              checked: _unref(switchForm).isUserName,
                              "onUpdate:checked": _cache[12] || (_cache[12] = ($event: any) => ((_unref(switchForm).isUserName) = $event)),
                              onChange: _unref(onChangenickName),
                              class: "fbh_switch_group_item"
                            }, null, 8, ["checked", "onChange"]),
                            _createVNode(_unref(aTooltip), null, {
                              title: _withCtx(() => [
                                _createTextVNode("开启功能需要选择一项作为登录的账号")
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_unref(QuestionCircleFilled))
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" 登录验证： "),
                            _createVNode(_unref(aSwitch), {
                              "checked-children": "开",
                              "un-checked-children": "关",
                              checked: _unref(switchForm).isLogin,
                              "onUpdate:checked": _cache[13] || (_cache[13] = ($event: any) => ((_unref(switchForm).isLogin) = $event)),
                              onChange: _unref(onChangeLoginVerify),
                              class: "fbh_switch_group_item font_size"
                            }, null, 8, ["checked", "onChange"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _createVNode(_unref(draggable), _mergeProps({
                            class: "custom_editor_tabs list-group",
                            handle: ".fbc_item_opera_move",
                            list: _unref(signupWatch).formArr
                          }, dragOptions.value, {
                            onChange: repeatChange,
                            onDrop: _unref(dragDrop)
                          }), {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(signupWatch).formArr, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: item.id
                                }, [
                                  _createVNode(_unref(VerifyItem), {
                                    modelValue: _unref(signupWatch).formArr[index],
                                    "onUpdate:modelValue": ($event: any) => ((_unref(signupWatch).formArr[index]) = $event),
                                    switchObj: _unref(switchForm),
                                    index: index,
                                    "edit-role": _unref(isShowEdit),
                                    childe: childe.value,
                                    formArr: _unref(signupWatch).formArr,
                                    modeData: modeData.value,
                                    "onDel:onDelItem": _unref(onDelItem),
                                    "onLogin:onChangeItemIsLogin": _unref(onChangeItemIsLogin),
                                    "onLogin:onChangeMergeStatus": _unref(onChangeItemIsMerge)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "switchObj", "index", "edit-role", "childe", "formArr", "modeData", "onDel:onDelItem", "onLogin:onChangeItemIsLogin", "onLogin:onChangeMergeStatus"])
                                ]))
                              }), 128))
                            ]),
                            _: 1
                          }, 16, ["list", "onDrop"]),
                          _createElementVNode("div", _hoisted_68, [
                            _createVNode(_component_a_button, {
                              class: "mod_modal_btn",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(onAddItem)()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("添加")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_button, {
                              class: "mod_modal_btn mod_type_primary2",
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(subForm)(_unref(studioId)))),
                              disabled: _unref(disabled)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("保存")
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["disabled"])),
            (_openBlock(), _createBlock(_unref(aTabPane), {
              key: 2,
              tab: "观众审核",
              disabled: _unref(userCache) === 1
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_69, [
                  _createVNode(_unref(ReviewList), {
                    activeKey: activeKey.value,
                    formArr: _unref(signupWatch).formArr
                  }, null, 8, ["activeKey", "formArr"])
                ])
              ]),
              _: 1
            }, 8, ["disabled"]))
          ]),
          _: 1
        }, 8, ["activeKey"])
      ])
    ], 2),
    _createVNode(_unref(aModal), {
      visible: _unref(infoModal).visible,
      "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((_unref(infoModal).visible) = $event)),
      title: _unref(infoModal).title,
      centered: _unref(infoModal).centered,
      okText: "导出记录",
      onOk: _unref(excel),
      width: "80%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("div", _hoisted_71, [
            _createVNode(_component_a_select, {
              class: "select_box",
              ref: "select",
              value: _unref(viewListObj).selectValue,
              "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_unref(viewListObj).selectValue) = $event)),
              style: {"width":"120px"},
              onChange: _unref(getViewList)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select_option, { value: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode("报名观看")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode("观看流水")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value", "onChange"]),
            _createVNode(_unref(aRangePicker), {
              style: {"width":"400px"},
              value: _unref(viewListObj).datetTimeValue,
              "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_unref(viewListObj).datetTimeValue) = $event)),
              "show-time": {
              hideDisabledOptions: true,
              defaultValue: [_unref(moment)('00:00:00', 'HH:mm:ss'), _unref(moment)('11:59:59', 'HH:mm:ss')],
            },
              format: "YYYY-MM-DD HH:mm:ss",
              onChange: _unref(getViewList)
            }, null, 8, ["value", "show-time", "onChange"])
          ]),
          _createVNode(_unref(aTable), {
            loading: _unref(showLoading),
            columns: _unref(columns),
            "row-key": (record) => record.id,
            "data-source": _unref(viewList),
            pagination: false
          }, {
            image: _withCtx(({ text }) => [
              text
                ? (_openBlock(), _createBlock(_unref(aImage), {
                    key: 0,
                    src: text
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loading", "columns", "row-key", "data-source"])
        ]),
        (_unref(viewList).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
              _createVNode(_unref(aPagination), {
                "show-quick-jumper": "",
                total: _unref(pageConfig).totalSize,
                current: _unref(pageConfig).current,
                "onUpdate:current": _cache[19] || (_cache[19] = ($event: any) => ((_unref(pageConfig).current) = $event)),
                "page-size": _unref(pageConfig).pageSize,
                "onUpdate:pageSize": _cache[20] || (_cache[20] = ($event: any) => ((_unref(pageConfig).pageSize) = $event)),
                pageSizeOptions: _unref(pageConfig).options,
                "show-less-items": "",
                "show-size-changer": "",
                onChange: _unref(getViewList),
                onShowSizeChange: _unref(getViewList)
              }, null, 8, ["total", "current", "page-size", "pageSizeOptions", "onChange", "onShowSizeChange"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "title", "centered", "onOk"]),
    _createVNode(CDelModal, {
      visible: _unref(delVisible),
      centered: "",
      close: _unref(openDelModal),
      ok: _unref(okDelModal)
    }, null, 8, ["visible", "close", "ok"]),
    _createVNode(_unref(aModal), {
      visible: showTips.value,
      "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((showTips).value = $event)),
      centered: "",
      onOk: reviewRegistration,
      onCancel: cancelModal,
      width: "500px"
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_73, [
          _createVNode(_unref(InfoCircleFilled), { class: "modal_icon" }),
          _createTextVNode("提示信息")
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_74
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})